export function joinPaths(path1, path2) {
    if (!path2) {
        return path1;
    }
    if (path1.endsWith('/') && path2.startsWith('/')) {
        return path1 + path2.slice(1);
    }
    if (!path1.endsWith('/') && !path2.startsWith('/')) {
        return path1 + '/' + path2;
    }
    return path1 + path2;
}
//# sourceMappingURL=util.js.map